<script lang="ts">
	import { twMerge } from "tailwind-merge";
	import { Mode } from "#gen/bundles/v1/service_pb.js";
	import DataToken from "#lib/components/DataToken.svelte";
	import { TokenProvider } from "#lib/tokenProvider.js";

	interface Props {
		provider?: TokenProvider;
		text?: string;
		mode: Mode;
		textClass?: string;
		badgeClass?: string;
	}

	const { provider = new TokenProvider(), text, textClass, badgeClass, mode }: Props = $props();
</script>

{#if text}
	{#if mode === Mode.EDITING}
		{#each provider.parse(text) as token, index (index)}
			{#if provider.instanceofSubstitutionToken(token)}
				<DataToken label={token.label} provider={token.provider} class={twMerge("pointer-events-none", badgeClass)} />
			{:else}
				<span class={textClass}>{token.value}</span>
			{/if}
		{/each}
	{:else}
		<span class={textClass}>{text}</span>
	{/if}
{/if}
